var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 167,
    viewBox: "0 0 167 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4410_10263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.176 10.7171C105.298 11.6877 115.317 15.6633 129.789 29.7769C143.43 43.0801 147.835 52.5253 149.129 56.1155C149.42 63.9137 149.603 72.9933 149.603 83.5003C149.603 111.558 148.299 129.439 147.11 139.913C146.24 147.572 140.49 153.3 132.833 154.194C123.039 155.336 107.043 156.563 83.4997 156.563C59.9565 156.563 43.96 155.336 34.166 154.194C26.5095 153.3 20.7595 147.572 19.8896 139.913C18.7001 129.439 17.3958 111.558 17.3958 83.5003C17.3958 55.4426 18.7001 37.5611 19.8896 27.0876C20.7595 19.4285 26.5095 13.6999 34.166 12.8067C43.96 11.6641 59.9565 10.4375 83.4997 10.4375C90.3536 10.4375 96.5684 10.5415 102.176 10.7171Z",
    fill: "#B7D5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.184 10.729C105.315 11.704 115.329 15.685 129.789 29.7862C143.363 43.0249 147.792 52.4433 149.11 56.0721C149.131 56.6361 149.152 57.207 149.172 57.7842C141.326 58.9476 127.072 58.0065 116.531 57.017C108.716 56.2833 102.569 50.1812 101.803 42.3684C100.792 32.0523 99.852 18.2398 101.074 10.6953C101.446 10.7062 101.817 10.7174 102.184 10.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5417 121.77H114.813",
    stroke: "#0A5290",
    strokeWidth: 9.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5417 90.457H100.896",
    stroke: "#0A5290",
    strokeWidth: 9.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6667 121.77H52.1875",
    stroke: "#0A5290",
    strokeWidth: 9.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6667 90.457H52.1875",
    stroke: "#0A5290",
    strokeWidth: 9.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.176 10.7171C105.298 11.6877 115.317 15.6633 129.789 29.7769C143.43 43.0801 147.835 52.5253 149.129 56.1155C149.42 63.9137 149.603 72.9933 149.603 83.5003C149.603 111.558 148.299 129.439 147.11 139.913C146.24 147.572 140.49 153.3 132.833 154.194C123.039 155.336 107.043 156.563 83.4997 156.563C59.9565 156.563 43.96 155.336 34.166 154.194C26.5095 153.3 20.7595 147.572 19.8896 139.913C18.7001 129.439 17.3958 111.558 17.3958 83.5003C17.3958 55.4426 18.7001 37.5611 19.8896 27.0876C20.7595 19.4285 26.5095 13.6999 34.166 12.8067C43.96 11.6641 59.9565 10.4375 83.4997 10.4375C90.3536 10.4375 96.5684 10.5415 102.176 10.7171Z",
    stroke: "#0A5290",
    strokeWidth: 9.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.172 57.7842C141.326 58.9476 127.072 58.0065 116.531 57.017C108.716 56.2833 102.569 50.1812 101.803 42.3684C100.792 32.0523 99.852 18.2398 101.074 10.6953",
    stroke: "#0A5290",
    strokeWidth: 9.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4410_10263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 167,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.409f7d7658897c7bcfea836989fbf0f1.svg";
export { ForwardRef as ReactComponent };